// extracted by mini-css-extract-plugin
module.exports = {"container":"ReferalRow_container__ojEqF","plan_purchase":"ReferalRow_plan_purchase__VZL54","no_purchase":"ReferalRow_no_purchase__3BDhj"};